export function canShowPersonBenefitsNav({
  canViewBeneficiaries,
  canViewGrpEnrollments,
  grpPersonProfileEnabled,
  canViewGrpCommission = false,
  commissionGrpPlatformEnabled = false
}: {
  canViewBeneficiaries: boolean;
  canViewGrpEnrollments: boolean;
  grpPersonProfileEnabled: boolean;
  canViewGrpCommission?: boolean;
  commissionGrpPlatformEnabled?: boolean;
}): boolean {
  return (
    canViewBeneficiaries ||
    (grpPersonProfileEnabled && canViewGrpEnrollments) ||
    (commissionGrpPlatformEnabled && canViewGrpCommission)
  );
}
